/**
 * Custom Variant Picker - Universal Handler
 * Handles clicks and interactions for custom variant cards
 */

document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit for variant-selects to be fully rendered
  setTimeout(() => {
    const variantSelects = document.querySelectorAll('variant-selects');
    
    variantSelects.forEach(variantSelect => {
      initializeVariantPicker(variantSelect);
    });
    
    // Fetch unit prices from product JSON
    fetchUnitPricesFromProduct();
  }, 100);
});

/**
 * Fetch unit price measurements from Shopify product.json
 */
async function fetchUnitPricesFromProduct() {
  const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
  if (!productHandle) {
     return;
  }

 
  try {
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
      console.warn('❌ Failed to fetch product.js:', response.status);
      return;
    }

    const productData = await response.json();
 
    
    let updatedCount = 0;
    
    // Update cards with unit price info from variants
    productData.variants.forEach(variant => {
 
      
      if (!variant.unit_price_measurement) {
         return;
      }

      const cards = document.querySelectorAll(`[data-variant-id="${variant.id}"]`);
      console.log('   📍 Found', cards.length, 'cards for this variant');
      
      cards.forEach(card => {
        const pricePerUnitEl = card.querySelector('.custom-variant-card__price-per-unit');
        if (pricePerUnitEl && variant.unit_price) {
          const unitPrice = variant.unit_price / 100; // Convert from cents
          const formatted = new Intl.NumberFormat('en-GB', { 
            style: 'currency', 
            currency: 'GBP' 
          }).format(unitPrice);
          
          const refValue = variant.unit_price_measurement.reference_value;
          const refUnit = variant.unit_price_measurement.reference_unit;
          
          const oldContent = pricePerUnitEl.innerHTML;
          pricePerUnitEl.innerHTML = `<strong>${formatted}</strong> p/${refValue}${refUnit}`;
          
           updatedCount++;
        }
      });
    });
    
   } catch (error) {
    console.error('❌ Error fetching unit prices:', error);
  }
}

/**
 * Update global stock bar based on selected variant card
 */
function updateGlobalStockBar(selectedCard) {
  const globalStockEl = document.querySelector('.custom-variant-global-stock');
  if (!globalStockEl) return;

  const variantStock = parseInt(selectedCard.dataset.variantStock) || 0;
  const stockPercent = parseInt(selectedCard.dataset.stockPercent) || 0;

  let stockStatus = 'medium';
  let stockText = 'Low stock';

  if (variantStock === 0) {
    stockStatus = 'low';
    stockText = 'Out of stock';
  } else if (stockPercent > 30) {
    stockStatus = 'high';
    stockText = 'In stock';
  }

  const textEl = globalStockEl.querySelector('.custom-variant-global-stock__text');
  const fillEl = globalStockEl.querySelector('.custom-variant-global-stock__fill');

  if (textEl) {
    textEl.className = `custom-variant-global-stock__text ${stockStatus}`;
    const spanEl = textEl.querySelector('span');
    if (spanEl) {
      spanEl.textContent = `${stockText} (${variantStock})`;
    }
  }

  if (fillEl) {
    fillEl.className = `custom-variant-global-stock__fill ${stockStatus}`;
    fillEl.style.width = `${stockPercent}%`;
  }
}

/**
 * Update sticky bar sync after variant selection
 */
function updateStickySync() {
  // Update sticky button text if function exists (defined in sticky bar snippet)
  if (typeof window.updateStickyCardsFunction === 'function') {
    window.updateStickyCardsFunction();
  }
}

function initializeVariantPicker(variantSelect) {
  const filterCards = variantSelect.querySelector('[data-filter-cards]');
  const detailCards = variantSelect.querySelector('[data-detail-cards]');
  const singleLevelCards = variantSelect.querySelector('[data-single-level-cards]');
  
  const filterSelect = variantSelect.querySelector('[data-filter-select]');
  const detailSelect = variantSelect.querySelector('[data-detail-select]');
  const singleDetailSelect = variantSelect.querySelector('[data-single-detail-select]');

  // Listen for clicks from sticky popup
  document.addEventListener('click', function(e) {
    const stickyCard = e.target.closest('.sticky-variants-popup .custom-variant-card');
    if (stickyCard) {
      const variantId = stickyCard.getAttribute('data-variant-id');
      // Find and select the corresponding main card
      const mainCard = document.querySelector('.custom-variant-cards .custom-variant-card[data-variant-id="' + variantId + '"]');
      if (mainCard && !mainCard.classList.contains('selected')) {
        mainCard.click();
      }
    }
  });

  // TWO LEVEL MODE: Filter + Detail
  if (filterCards && detailCards && filterSelect && detailSelect) {
    setupTwoLevelPicker(variantSelect, filterCards, detailCards, filterSelect, detailSelect);
  }
  
  // SINGLE LEVEL MODE: Only Detail
  if (singleLevelCards && singleDetailSelect) {
    setupSingleLevelPicker(variantSelect, singleLevelCards, singleDetailSelect);
  }
}

/**
 * Setup Two-Level Picker (Filter + Detail)
 */
function setupTwoLevelPicker(variantSelect, filterCards, detailCards, filterSelect, detailSelect) {
  // Handle filter card clicks
  const filterButtons = filterCards.querySelectorAll('.custom-variant-card--filter');
  
  filterButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const filterValue = this.getAttribute('data-filter');
      
      // Update selected state on filter cards
      filterButtons.forEach(btn => btn.classList.remove('selected'));
      this.classList.add('selected');
      
      // Update hidden select
      filterSelect.value = filterValue;
      
      // Update label
      const filterLabel = variantSelect.querySelector('[data-filter-value]');
      if (filterLabel) {
        filterLabel.textContent = filterValue;
      }
      
      // Show/hide detail cards based on filter
      filterDetailCards(detailCards, filterValue);
      
      // Select first available detail variant for this filter
      selectFirstDetailVariant(detailCards, filterValue, detailSelect);
      
      // Update sticky bar sync
      updateStickySync();
      
      // IMPORTANT: Wait for DOM to update before calling onVariantChange
      setTimeout(() => {
        if (typeof variantSelect.onVariantChange === 'function') {
          variantSelect.onVariantChange();
        } else if (typeof variantSelect.updateOptions === 'function' && typeof variantSelect.updateMasterId === 'function') {
          variantSelect.updateOptions();
          variantSelect.updateMasterId();
        } else {
          const finalChangeEvent = new Event('change', { bubbles: true });
          variantSelect.dispatchEvent(finalChangeEvent);
        }
      }, 0);
    });
  });
  
  // Handle detail card clicks
  const detailLabels = detailCards.querySelectorAll('.custom-variant-card--detail');
  
  detailLabels.forEach(label => {
    label.addEventListener('click', function(e) {
      const input = this.querySelector('input[type="radio"]');
      if (input) {
        // IMPORTANT: Mark input as checked FIRST
        input.checked = true;
        
        // Get the filter value from this card
        const cardFilterValue = this.getAttribute('data-filter');
        
        // Make sure we're in the right filter context
        if (cardFilterValue && filterSelect.value !== cardFilterValue) {
          filterSelect.value = cardFilterValue;
          
          // Update filter UI
          const filterButtons = filterCards.querySelectorAll('.custom-variant-card--filter');
          filterButtons.forEach(btn => {
            if (btn.getAttribute('data-filter') === cardFilterValue) {
              btn.classList.add('selected');
            } else {
              btn.classList.remove('selected');
            }
          });
        }
        
        // Update selected state
        detailLabels.forEach(lbl => lbl.classList.remove('selected'));
        this.classList.add('selected');
        
        // Update global stock bar
        updateGlobalStockBar(this);
        
        // Update sticky bar sync
        updateStickySync();
        
        // Update hidden select
        detailSelect.value = input.value;
        
        // Update label
        const detailLabel = variantSelect.querySelector('[data-detail-value]');
        if (detailLabel) {
          detailLabel.textContent = input.value;
        }
        
        // IMPORTANT: Wait for DOM to update before calling onVariantChange
        setTimeout(() => {
          if (typeof variantSelect.onVariantChange === 'function') {
            variantSelect.onVariantChange();
          } else if (typeof variantSelect.updateOptions === 'function' && typeof variantSelect.updateMasterId === 'function') {
            variantSelect.updateOptions();
            variantSelect.updateMasterId();
          } else {
            const finalChangeEvent = new Event('change', { bubbles: true });
            variantSelect.dispatchEvent(finalChangeEvent);
          }
        }, 0);
      }
    });
  });
  
  // Initialize: Show only cards for selected filter
  let selectedFilter = filterSelect.value;
  
  // If no value, get the first option's value
  if (!selectedFilter) {
    const firstOption = filterSelect.querySelector('option[selected], option:first-child');
    if (firstOption) {
      selectedFilter = firstOption.value;
      filterSelect.value = selectedFilter;
    }
  }
  
  if (selectedFilter) {
    filterDetailCards(detailCards, selectedFilter);
    
    // Ensure a detail card is selected
    const selectedDetailCard = detailCards.querySelector('.custom-variant-card--detail.selected');
    if (!selectedDetailCard) {
      selectFirstDetailVariant(detailCards, selectedFilter, detailSelect);
    }
  }
}

/**
 * Setup Single-Level Picker (Only Detail)
 */
function setupSingleLevelPicker(variantSelect, singleLevelCards, singleDetailSelect) {
  const detailLabels = singleLevelCards.querySelectorAll('.custom-variant-card');
  
  detailLabels.forEach(label => {
    label.addEventListener('click', function(e) {
      const input = this.querySelector('input[type="radio"]');
      if (input) {
        // IMPORTANT: Mark input as checked FIRST
        input.checked = true;
        
        // Update selected state
        detailLabels.forEach(lbl => lbl.classList.remove('selected'));
        this.classList.add('selected');
        
        // Update global stock bar
        updateGlobalStockBar(this);
        
        // Update sticky bar sync
        updateStickySync();
        
        // Update hidden select
        singleDetailSelect.value = input.value;
        
        // Update label
        const singleLabel = variantSelect.querySelector('[data-single-value]');
        if (singleLabel) {
          singleLabel.textContent = input.value;
        }
        
        // IMPORTANT: Wait for DOM to update before calling onVariantChange
        setTimeout(() => {
          if (typeof variantSelect.onVariantChange === 'function') {
            variantSelect.onVariantChange();
          } else if (typeof variantSelect.updateOptions === 'function' && typeof variantSelect.updateMasterId === 'function') {
            variantSelect.updateOptions();
            variantSelect.updateMasterId();
          } else {
            const finalChangeEvent = new Event('change', { bubbles: true });
            variantSelect.dispatchEvent(finalChangeEvent);
          }
        }, 0);
      }
    });
  });
}

/**
 * Filter detail cards based on selected filter value
 */
function filterDetailCards(detailCards, filterValue) {
  const allCardWrappers = detailCards.querySelectorAll('.custom-variant-card-wrapper');
  
  allCardWrappers.forEach(wrapper => {
    const label = wrapper.querySelector('.custom-variant-card--detail');
    if (label) {
      const cardFilterValue = label.getAttribute('data-filter');
      
      if (cardFilterValue === filterValue) {
        wrapper.style.display = '';
      } else {
        wrapper.style.display = 'none';
      }
    }
  });
}

/**
 * Select first available detail variant for the selected filter
 */
function selectFirstDetailVariant(detailCards, filterValue, detailSelect) {
  const visibleCards = Array.from(detailCards.querySelectorAll('.custom-variant-card-wrapper'))
    .filter(wrapper => {
      const label = wrapper.querySelector('.custom-variant-card--detail');
      return label && label.getAttribute('data-filter') === filterValue;
    });
  
  if (visibleCards.length > 0) {
    // Find first available (not disabled) card
    const firstAvailable = visibleCards.find(wrapper => {
      const label = wrapper.querySelector('.custom-variant-card--detail');
      return label && !label.classList.contains('disabled');
    });
    
    const cardToSelect = firstAvailable || visibleCards[0];
    const label = cardToSelect.querySelector('.custom-variant-card--detail');
    const input = label.querySelector('input[type="radio"]');
    
    if (input) {
      // Update selected state
      detailCards.querySelectorAll('.custom-variant-card--detail').forEach(lbl => {
        lbl.classList.remove('selected');
      });
      label.classList.add('selected');
      
      // Update global stock bar
      updateGlobalStockBar(label);
      
      // Update sticky bar sync
      updateStickySync();
      
      // Check the radio button
      input.checked = true;
      
      // Update hidden select
      detailSelect.value = input.value;
      
      // Update label
      const detailLabel = detailCards.closest('variant-selects').querySelector('[data-detail-value]');
      if (detailLabel) {
        detailLabel.textContent = input.value;
      }
    }
  }
}

/**
 * Trigger variant change event
 */
function triggerVariantChange(variantSelect) {
  const allSelects = variantSelect.querySelectorAll('select[data-option-position]');
  
  const changeEvent = new Event('change', { bubbles: true });
  variantSelect.dispatchEvent(changeEvent);
}
